import { useState, useEffect, useCallback } from "react";
import { SimpleGrid, IconButton, Button } from "@chakra-ui/react";
import Loading from "../Component/Loading/loading";
import apiService from "../Method/Permission_Service.js";
import { ThemeProvider } from "@mui/material/styles";
import MUIDataTable from "mui-datatables";
import theme from "../assets/Table/TableTheme";
import options from "../assets/Table/TableOption_NoPrint";
import { EditIcon } from "@chakra-ui/icons";
import renderPermissionTile from "../Component/Permission_Card/permission_card";
import InputText from "../Component/Input/Input";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { t } from "i18next";

const columns = (handleDelete, handleEdit) => [
    {
        name: "_id",
        label: "ID",
        options: { filter: false, sort: false, display: false, viewColumns: false },
    },

    {
        name: "PERMISSION_NAME",
        label: t("PERMISSION_NAME"),
        options: { filter: false, sort: false },
    },

    {
        name: "PERMISSION",
        label: "PERMISSION",
        options: { filter: false, sort: false, display: false, viewColumns: false },
    },
    {
        name: "",
        label: t("Edit"),
        options: {
            filter: false,
            sort: false,
            viewColumns: false,
            customBodyRender: (value, tableMeta) => (
                <IconButton onClick={() => handleEdit(tableMeta)} className="TableIcon">
                    <EditIcon />
                </IconButton>
            ),
        },
    },

    {
        name: "",
        label: t("Delete"),
        options: {
            filter: false,
            sort: false, viewColumns: false,
            customBodyRender: (value, tableMeta) => (
                <IconButton
                    style={{ color: "red" }}
                    onClick={() => handleDelete(tableMeta)}>
                    <DeleteIcon />
                </IconButton>
            ),
        },
    },
];

function App() {

    const [ID, setID] = useState("");
    const [Edit, isEdit] = useState(false);
    const [USER_NAME, setUSER_NAME] = useState("");
    const [data, setData] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [permissions, setPermissions] = useState({});

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const { success, data, error } = await apiService.get();
            if (success) {
                setData(data);
            } else {
                setError(error.message);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleClear = () => {
        setUSER_NAME("");
        setError("");
        setID("");
        isEdit(false);
        setPermissions({});
    };

    const handleEdit = useCallback((data) => {
        const row = data.rowData;
        setID(row[0]);
        setUSER_NAME(row[1]);
        isEdit(true);

        setPermissions(
            row[2] && Object.keys(row[2]).length > 0
                ? row[2]
                : {}
        );
        window.scrollTo({ top: 0, behavior: 'smooth' });

    }, []);



    const handleDelete = async (data) => {
        const row = data.rowData;
        await Swal.fire({
            icon: "error",
            title: `${t("Confirm_msg")} ${row[1]}`,
            focusConfirm: false,
            showCancelButton: true,
            customClass: {
                container: "alertContainer",
                popup: "alertPopUp",
                title: "title",
                confirmButton: "confirm",
                cancelButton: "cancel",
            },
            preConfirm: async () => {
                const { success, error } = await apiService.delete(row[0]);
                if (success) {
                    setData((prev) => prev.filter((item) => item._id !== row[0]));
                    handleClear();
                } else {
                    setError(error?.message);
                }
            },
        });
    };
    const togglePermission = (key) => {
        setPermissions((prev) => {
            return {
                ...prev,
                [key]: !prev[key],
            };
        });
    };
    const handleInsert = async (e) => {
        e.preventDefault();


        const payload = {
            id: ID,
            PERMISSION_NAME: USER_NAME,
            PERMISSION: { ...permissions }
        };

        console.log(payload)

        const { success, error } = await apiService.post(payload, Edit ? "UPDATE_PERMISSION" : "INSERT_PERMISSION");

        if (success) {
            fetchData();
            handleClear();
        } else {
            setError(error.response?.data?.message || "حدث خطأ أثناء الحفظ");
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <div style={{ width: "100%", }} className={"Total_Header_Without_Bg"}>


                <form onSubmit={handleInsert}>
                    <InputText
                        type="text"
                        required
                        value={USER_NAME}
                        labels={t("PERMISSION_NAME")}
                        onChange={(value) => setUSER_NAME(value)}
                    />


                    <SimpleGrid
                        gap={2}
                        columns={{ base: 1, md: 2, lg: 2, "2xl": 2 }}
                        style={{ marginInline: "5px", marginTop: "15px" }}
                    >
                        {renderPermissionTile(
                            "MAIN_PERMISSIONS",
                            [
                                "ENABLE_SALES",
                                "ENABLE_RETURN_SALES",
                                "ENABLE_CLIENT",
                                "ENABLE_CLIENT_BALANCE",
                                "ENABLE_VISITOR",
                                "ENABLE_ACCOUNTING",
                                "ENABLE_PRODUCT",
                                "ENABLE_REPORTING",
                                "ENABLE_VIEW_DELIVERY_ORDERS",
                                "ENABLE_EDIT_ORDER_AFTER_PUBLISH",
                                "ENABLE_VIEW_ORDER_AFTER_ACCEPT",
                                "ENABLE_VIEW_SYSTEM_ORDER",
                                "ENABLE_APPLICATION_STATUS",
                                "ENABLE_SHOW_PREVIEW_CLIENT_BALANCE",
                                "SHOW_AND_HIDE_ITEM"
                            ],
                            permissions,
                            togglePermission
                        )}

                        {renderPermissionTile(
                            "ENABLE_SALES",
                            [
                                "ENABLE_OFFERS",
                                "ENABLE_IS_PAYMENT_NEGATIVE",
                                "ENABLE_DELIVERY_AREA",
                                "ENABLE_SAVE_SALES",
                                "ENABLE_EDIT_SALES",
                                "ENABLE_DELETE_SALES",
                                "ENABLE_LOCATION_REQUIRED",
                                "ENABLE_CHANGE_PRICE_TYPE",
                                "ENABLE_DISCOUNT",
                                "ENABLE_FREE_ITEM",
                                "ENABLE_CHECK_CLIENT_PHONE",
                                "ENABLE_PHONE_REQUIRED",
                                "ENABLE_NOT_BRING_CLIENT_PHONE",
                                "CHECK_MANDOOB_LOCATION_ON_CHANGE_INVOICE_STATUS",
                            ],
                            permissions,
                            togglePermission
                        )}

                        <SimpleGrid gap={2} columns={1}>
                            {renderPermissionTile(
                                "ENABLE_CLIENT",
                                [
                                    "ENABLE_ADD_CLIENT",
                                    "ENABLE_ALLOW_EDIT_CLIENT_BEFORE_PUBLISH",
                                    "ENABLE_CUSTOMER_TRANSACTIONS"
                                ],
                                permissions,
                                togglePermission
                            )}

                            {renderPermissionTile(
                                "ENABLE_ACCOUNTING",
                                [
                                    "ENABLE_ADD_SANAD_DOLLAR",
                                    "ENABLE_ADD_SANAD_DINAR",
                                    "ENABLE_SAVE_SANAD",
                                    "ENABLE_EDIT_SANAD",
                                    "ENABLE_DELETE_SANAD",
                                ],
                                permissions,
                                togglePermission
                            )}
                        </SimpleGrid>



                        <SimpleGrid gap={2} columns={1}>
                            {renderPermissionTile(
                                "ENABLE_REPORTING",
                                [
                                    "ENABLE_DETAILED_MATERIAL_SALES_REPORT",
                                    "ENABLE_SALES_REPORT",
                                    "ENABLE_SALE_ITEM_BEFORE_PUBLISH",
                                    "ENABLE_STORE_ITEM_REPORT",
                                    "ENABLE_CUSTOMER_DEBIT_REPORT",

                                ],
                                permissions,
                                togglePermission
                            )}

                            {renderPermissionTile(
                                "ENABLE_APPLICATION_STATUS",
                                [
                                    "ENABLE_APPLICATION_STATUS_OFFLINE",
                                    "ENABLE_APPLICATION_STATUS_ONLINE",
                                    "ENABLE_CHANGE_APPLICATION_STATUS",
                                ],
                                permissions,
                                togglePermission
                            )}
                        </SimpleGrid>



                    </SimpleGrid>


                    <Button type="submit" className="Permission-btn" mt={"15px"} >
                        {t("save")}
                    </Button>
                </form>

            </div>

            {error && <p className="error-message">{error}</p>}
            {isLoading && <Loading />}

            {
                !isLoading && (
                    <div style={{ width: "100%", overflowX: "auto", marginTop: "10px" }}
                        className={Edit === false ? "Total_Header_Without_Bg" : ""
                        }
                    >
                        <MUIDataTable
                            title={""}
                            data={data}
                            columns={columns(handleDelete, handleEdit)}
                            options={options}
                        />
                    </div>
                )
            }
        </ThemeProvider >
    );
}

export default App;
